import { BaseListResponseDto, PaginationQueryParams } from './common.dtos';

export enum OrderTypeIntDto {
  Market = 1,
  Limit = 2,
  Stop_Market = 3,
  Stop_Limit = 4,
  Market_On_Close = 5,
}

export enum OrderTypeDto {
  Market = 'Market',
  Limit = 'Limit',
  StopMarket = 'Stop_Market',
  StopLimit = 'Stop_Limit',
  MarketOnClose = 'Market_On_Close',
}

export enum OrderActionIntDto {
  Buy = 1,
  Sell = 2,
}

export enum OrderActionDto {
  Buy = 'Buy',
  Sell = 'Sell',
}

export enum OrderDurationDto {
  Day = 'Day',
  GTC = 'GTC',
}

export enum OrderDurationIntDto {
  Day = 1,
  GTC = 2,
}

export enum OrderStatusIntDto {
  New = 1,
  PartiallyFilled,
  Filled,
  DoneForDay,
  Cancelled,
  Replaced,
  PendingCancel,
  Stopped,
  Rejected,
  Suspended,
  PendingNew,
  Calculated,
  Expired,
  PendingReplace,
  Saved,
  LiveUntriggered,
  Scheduled,
  OCO_Untriggered,
  CancelledUntriggered,
  Initiated,
  ReplaceInitiated,
  CancelInitiated,
  CancelRejected,
  ReplaceRejected,
  Busted,
  PreAllocated,
  Acknowledged,
  PartiallyCancelled,
}

export interface OrderEventDto {
  Description?: string;
  FillPrice: number;
  FillQuantity: number;
  Limit: number;
  OrderStatus: OrderStatusIntDto;
  Stop: number;
  Symbol?: string;
  TimeStamp: string;
}

export enum OrderStatusDto {
  New = 'New',
  PartiallyFilled = 'PartiallyFilled',
  Filled = 'Filled',
  DoneForDay = 'DoneForDay',
  Cancelled = 'Cancelled',
  Replaced = 'Replaced',
  PendingCancel = 'PendingCancel',
  Stopped = 'Stopped',
  Rejected = 'Rejected',
  Suspended = 'Suspended',
  PendingNew = 'PendingNew',
  Calculated = 'Calculated',
  Expired = 'Expired',
  PendingReplace = 'PendingReplace',
  Saved = 'Saved',
  LiveUntriggered = 'LiveUntriggered',
  Scheduled = 'Scheduled',
  OCO_Untriggered = 'OCO_Untriggered',
  CancelledUntriggered = 'CancelledUntriggered',
  Initiated = 'Initiated',
  ReplaceInitiated = 'ReplaceInitiated',
  CancelInitiated = 'CancelInitiated',
  CancelRejected = 'CancelRejected',
  ReplaceRejected = 'ReplaceRejected',
  Busted = 'Busted',
  PreAllocated = 'PreAllocated',
  Acknowledged = 'Acknowledged',
  PartiallyCancelled = 'PartiallyCancelled',
}

export interface OrderDto {
  AccountId: number;
  AllOrNone: boolean;
  AverageFillPrice?: number;
  BypassWarnings?: boolean;
  ClientRefId?: number;
  CommissionType?: string;
  CommissionAssessed: number;
  Date: string;
  Description?: string;
  Duration: OrderDurationIntDto;
  FillQuantity?: number;
  Legs?: Array<{
    Action?: OrderActionIntDto;
    AssetType?: string;
    AverageLegFillPrice?: number;
    CallPut?: boolean;
    LegFillQuantity?: number;
    PositionEffect?: string;
    SpreadRatio?: number;
    Symbol?: string;
  }>;
  OrderId: number;
  OrderStatus: OrderStatusIntDto;
  OrderType: OrderTypeIntDto;
  Price?: number;
  Quantity: number;
  Stop?: number;
  UnderlyingSymbol?: string;
}

export interface OrderDetailsDto extends OrderDto {
  OrderEvents: OrderEventDto[];
}

interface BaseOrderParamsDto {
  accountId: number;
}

export type CreateOrderBodyDto = {
  duration?: OrderDurationDto;
  orderType?: OrderTypeDto;
  action?: OrderActionDto;
  price?: number;
  stop?: number;
  quantity?: number;
  symbol?: string;
};

export interface CreateOrderDto {
  params: BaseOrderParamsDto;
  body: CreateOrderBodyDto;
}

export interface GetOrderParamsDto extends BaseOrderParamsDto {
  id: string;
}

export interface GetOrderDto {
  params: GetOrderParamsDto;
}

export interface CancelOrderParamsDto extends BaseOrderParamsDto {
  id: string;
}

export interface CancelOrderDto {
  params: CancelOrderParamsDto;
}

export interface GetOrderListQueryParamsDto extends PaginationQueryParams {
  dateFrom?: string;
  dateTo?: string;
  symbol?: string;
}

export interface GetOrderListDto {
  params: BaseOrderParamsDto;
  queryParams?: GetOrderListQueryParamsDto;
}

export interface GetOrderListResponseDto extends BaseListResponseDto<OrderDto[]> {}
